{
  "version": "1.2.6",
  "objects": {
    "7493635533072202012": {
      "type": "frame",
      "id": "7493635533072202012",
      "z": 1506,
      "textContent": "",
      "left": 185.17597385098043,
      "top": 438.77235351656907,
      "width": 400,
      "height": 500,
      "scaleX": 1.504105723828775,
      "scaleY": 0.7153926348357298,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 20,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7493635533084430521": {
      "type": "frame",
      "id": "7493635533084430521",
      "z": 1516,
      "textContent": "Frame 14",
      "left": 426.4555005147218,
      "top": 458.77235351656907,
      "width": 400,
      "height": 500,
      "scaleX": 0.8509069071694215,
      "scaleY": 0.6353926348357298,
      "fill": "transparent",
      "opacity": 0.02,
      "container": "7493635533072202012",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a2",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7493635533073222109": {
      "type": "frame",
      "id": "7493635533073222109",
      "z": 1526,
      "textContent": "Frame 23",
      "left": 426.4555005147218,
      "top": 514.7723535165691,
      "width": 400,
      "height": 500,
      "scaleX": 0.8509069071694215,
      "scaleY": 0.4433926348357299,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533084430521",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7493635533083877844": {
      "type": "shape",
      "id": "7493635533083877844",
      "z": 1586,
      "shapeName": "text",
      "textContent": "<p>Paragraph text</p>",
      "left": 436.4555005147218,
      "top": 524.7723535165691,
      "width": 101.55956032803472,
      "height": 29.870458920010215,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.004336762295373,
      "scaleY": 1.004336762295373,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.4,
      "textAlign": "left",
      "fontSize": 14.060714672135221,
      "angle": 0,
      "container": "7493635533073222109",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7493635533089005845": {
      "type": "frame",
      "id": "7493635533089005845",
      "z": 1536,
      "textContent": "Frame 23",
      "left": 426.4555005147218,
      "top": 736.468670934434,
      "width": 400,
      "height": 500,
      "scaleX": 0.8509069071694215,
      "scaleY": 0.08,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533084430521",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "bottom"
    },
    "7493635533093409251": {
      "type": "wireframe",
      "id": "7493635533093409251",
      "z": 1556,
      "top": 737.609295934434,
      "left": 426.4555005147218,
      "width": 93.2548828125,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7493635533089005845",
      "wireframeName": "button",
      "fill": "#349F68",
      "textColor": null,
      "style": "square",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Read more" }
    },
    "7493635533104494498": {
      "type": "wireframe",
      "id": "7493635533104494498",
      "z": 1566,
      "top": 737.468670934434,
      "left": 529.7103833272217,
      "width": 97.46875,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7493635533089005845",
      "wireframeName": "button",
      "fill": "#349F68",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": {
        "state": "default",
        "value": "Explore",
        "iconLeft": null,
        "iconRight": { "prefix": "fas", "iconName": "person-hiking" }
      }
    },
    "7493635533090828839": {
      "type": "shape",
      "id": "7493635533090828839",
      "z": 1576,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#19575A\">Title</span></p>",
      "left": 426.4555005147218,
      "top": 458.77235351656907,
      "width": 35.773429338068794,
      "height": 29.460471219586065,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.900852148039295,
      "scaleY": 1.900852148039295,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 26.61193007255013,
      "angle": 0,
      "container": "7493635533084430521",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "Zy",
      "maskType": "none",
      "locked": false
    },
    "7493635533092195547": {
      "type": "frame",
      "id": "7493635533092195547",
      "z": 1546,
      "textContent": "Frame 2",
      "left": 205.17597385098043,
      "top": 458.77235351656907,
      "width": 400,
      "height": 500,
      "scaleX": 0.5031988166593534,
      "scaleY": 0.6353926348357298,
      "fill": "#1CBA68",
      "opacity": 0.05,
      "container": "7493635533072202012",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "parent",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    }
  }
}
